import script from "./gradeSimulate.vue?vue&type=script&setup=true&lang=ts"
export * from "./gradeSimulate.vue?vue&type=script&setup=true&lang=ts"

import "./gradeSimulate.vue?vue&type=style&index=0&id=20d9ef12&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20d9ef12"]])

export default __exports__